<template>
  <div class="ls_spin_container">
    <Button
      v-if="display_create_button"
      type="success"
      class="ls_create_button"
      :to="{ name: item_type + '_create' }"
      >Создать
    </Button>
    <Row :gutter="6" type="flex">
      <cardColumn v-for="el of data" :key="el.id">
        <Card class="item_card">
          <!--<p slot="title" class="item_card_subheader"></p>-->

          <Row :gutter="16">
            <Col span="7" class="item_card_image">
              <img
                :src="item_image_url"
                @click="
                  $router.push({
                    name: 'account_detail',
                    params: { id: el.id }
                  })
                "
              />
            </Col>
            <Col span="17">
              <Row>
                <Col :xs="24" :sm="24" :md="24" :lg="13"><h2
                        class="item_card_header"
                        @click="
                  $router.push({
                    name: 'account_detail',
                    params: { id: el.id }
                  })
                "
                >{{ el.name }}</h2></Col>
                <Col :xs="24" :sm="24" :md="24" :lg="11">
                  <Tag color="success" style="float: right;">{{
                  el.type_display
                  }}</Tag>
                  <Tag color="warning" style="float: right;" v-if="el.fiscal">Фискальный</Tag>
                  <Tag v-if="el.deleted_date" color="error" style="float: right;">Удален</Tag></Col>
              </Row>

              <div class="item_card_content">
                <p>Создан {{ formatDateTime(el.created_date) }}</p>
                <p>Баланс {{ formatNumber(el.balance) }} {{ currency }}</p>
              </div>
            </Col>
            <div class="item_actions">
              <Button
                v-if="display_edit_button_by_item(el)"
                type="primary"
                ghost
                @click="
                  $router.push({ name: 'account_edit', params: { id: el.id } })
                "
              >
                <Icon type="ios-create-outline" size="16" />
                Редактировать
              </Button>
              <Button
                v-if="display_delete_button_by_item(el)"
                type="error"
                ghost
                @click="deleteItem(el.id)">
                <Icon type="ios-trash-outline" size="16" />
                Удалить
              </Button>
            </div>
          </Row>
        </Card>
      </cardColumn>
    </Row>
    <accountItem
      :id="item.id"
      :action="item.action"
      v-model="item.show"
      @reload-table="fetchItems"
      :base_view_url="baseViewUrl"
      :item_type="item_type"
    ></accountItem>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { base_url, server_addr } from "../../http.js";
import accountItem from "@/apps/account/accountItem.vue";
import cardColumn from "@/components/core/cardColumn.vue";
import { BaseCardListData } from "../../base/base_card_list.js";

let _app = BaseCardListData();
_app.components = {
  accountItem,
  cardColumn
};
_app.data = function() {
  return {
    // Base settings
    baseViewUrl: base_url + "/accounts/",
    item_type: "account",
    loading: true,

    data: [],
    item_image_url: "./static/img/account_v2_99x84.png",

    item: {
      show: false,
      id: null,
      action: null
    }
  };
};
export default _app;
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/apps/account/account.vue